<button
  [cdkCopyToClipboard]="getData()"
  (cdkCopyToClipboardCopied)="copiedDataSuccess()"
  [matTooltip]="'Copier'"
  mat-button
  type="button"
>
  <mat-icon>copy_all</mat-icon>
</button>
